import {Image, Row} from 'react-bootstrap';
import LazyLoad from 'react-lazyload';
import React, {useState, useEffect} from 'react';
import './style.css';


const MyLoader = props => (
    <div className="image_box_loader_div" style={{ width: props.width ? props.width : '100%', height: props.height ? props.height : '100%'}}>
    </div>
)


const ImageElement = ({ idx, image_src, default_image_style, image_style, loaded, set_loaded }) => {
	return (
		<LazyLoad offset={185} overflow={true} scroll={true}>
        <Image 
        	className="image_box_internal_image"
        	onLoad = {(e) => {
                set_loaded(true);
            }}
            style={{ ...default_image_style, ...image_style, display: loaded ? 'block' : 'none' , visibility:(loaded?'visible':'hidden')}} 
            key={'horizonal-scroll-tempates'+idx}  
            src={image_src} 
            alt={'Image Not Found'}
            id={"image_box_internal_image" + image_src}
        />
        </LazyLoad>	
	);
}


const ImageBox = ({ max_container_height, boxed_view, show_preview_loader, on_click, name, idx, image_src, container_style, image_style, overlay_style, title_style, disable_overlay, footer_text, context_menu, skeleton, skeleton_width, skeleton_height, text_loader }) => {
	try {
		const default_container_style = {
			marginRight: 5,
			marginLeft: 5, 
			marginTop: 10,
			display: 'inline-block'
		};

		const [ loaded, set_loaded ] = useState(false);
		const [ padding_top, set_padding_top ] = useState(5);

		const default_image_style = {
			borderRadius: 6, 
			cursor: 'pointer', 
			height: 120
		};

		useEffect(() => {
			if (loaded && boxed_view) {
				// console.log('inside', (max_container_height - Number(window.document.getElementById('image_box_internal_image' + image_src).height)) / 2);
				set_padding_top((max_container_height - window.document.getElementById('image_box_internal_image' + image_src).height) / 2);
			}
		}, [ loaded ])

		return (
			<div key={idx} className="wizard_slider_container" onClick={on_click} style={{ ...default_container_style, ...container_style }}>
				{context_menu}
				{skeleton?(<div className="image_box_skeleton" id={image_src} style={{ ...default_image_style, ...image_style, boxShadow: 'unset', width:skeleton_width || 160, height:skeleton_height || 160, display: loaded ? 'none' : 'block' , visibility: (loaded?'hidden':'visible')}} ><MyLoader width={skeleton_width || 160} height={skeleton_height || 160} /></div>):''}
				{boxed_view ? (
					<div style={{ borderRadius:6, height: loaded?max_container_height:0, backgroundColor: '#f1f2f3', padding:6, paddingTop: padding_top }}>
						<ImageElement 
							idx={idx}
							image_src={image_src}
							default_image_style={default_image_style}
							image_style={image_style}
							loaded={loaded}
							set_loaded={set_loaded}			
						/>
					</div>
					) : (
					<ImageElement 
						idx={idx}
						image_src={image_src}
						default_image_style={default_image_style}
						image_style={image_style}
						loaded={loaded}
						set_loaded={set_loaded}			
					/>
				)}
				{footer_text && <Row><h6 style={{'textAlign': 'center', 'width': '100%', overflow: 'hidden'}}><b>{footer_text}</b></h6></Row>}
                {!disable_overlay && (
                	<>
                	{
                		show_preview_loader?( <div className="wizard_slider_overlay wizard_slider_overlay_show" style={overlay_style}>
		            		<h6 className="wizard_slider_title" style={title_style} >Swapping Style...</h6>
		            	</div>):( <div className="wizard_slider_overlay" style={overlay_style}>
		            		<h6 className="wizard_slider_title" style={title_style} >{name}</h6>
		            	</div>)
	                }
                	</>
                )}
				{text_loader ? (
					<div className="image_box_skeleton" style={{ marginTop: 12, ...default_image_style, ...image_style, boxShadow: 'unset', width: 100, height: 8 }} ><MyLoader width={100} height={8} /></div>
				) : ''}
            </div>
		)
	} catch(err) {
		console.log('error in image box', err);
		return 'Image box failed'
	}
};

ImageBox.defaultProps = {
	image_style : {},
	container_style: {},
	title_style: {},
	disable_overlay: false
};

export default ImageBox;